export const BACKEND_URL_FROM_ENV = "https://backend.indewild.com";
